<script setup lang="ts">
import type {ArticleAsset} from '@/types';
import {HomeFeature, HomeFeatureTile, HomeFeatureContent, HomeFeatureContentLogo, HomeFeatureContentBody} from '@/lib/ui/home-feature';

const showStayInTheLoop = ref(false);

const {translate} = useTranslation();
const data = ref();

if (import.meta.client) {
  const {data: lazyResp, error} = await useLazyFetch<ArticleAsset>(`/api/asset-by-slug?slug=times-travel-home-feature&status=${window ? (window.location !== window.parent.location ? 'draft' : 'published') : 'published'}`, {server: false});

  if (lazyResp.value && !error) {
    data.value = lazyResp.value as ArticleAsset;
  }

  watch(lazyResp, () => {
    data.value = lazyResp.value as ArticleAsset;
  });
}
</script>

<template>
  <HomeFeature class="bg-[var(--times-travel-color-lighter)]">
    <template v-if="data">
      <HomeFeatureTile>
        <img :src="data.fields.feature_image.public_url" alt="Times Travel + Viewing Deck Tile Image" />
        <img v-gsap.whenVisible.once.reversible.from="{opacity: 0, y: '20%'}" :src="data.fields.feature_icon.public_url" alt="Times Travel + Viewing Deck Logo" class="mobile-only" />
      </HomeFeatureTile>

      <HomeFeatureContent class="bg-[url('/assets/times-travel/discreet-scroll-shape-bg.svg')] bg-no-repeat">
        <HomeFeatureContentLogo :reverse="true">
          <img :src="data.fields.feature_icon.public_url" alt="Times Travel + Viewing Deck" />
        </HomeFeatureContentLogo>

        <HomeFeatureContentBody>
          <h3 class="text-white" v-html="translate(data.fields.sub_title)" />

          <div class="text-white" v-html="translate(data.fields.content)" />

          <h3 class="text-white">Join the waitlist and be the first to know when ticket sales open</h3>

          <ul class="flex gap-[2rem]">
            <TheButton tag="NuxtLink" class="!border-none !bg-[var(--times-travel-color-darker)] !py-4 hover:!bg-black hover:!text-white" aria-label="Join the waitlist" @click="showStayInTheLoop = true">Join the waitlist</TheButton>
          </ul>
        </HomeFeatureContentBody>
      </HomeFeatureContent>
      <Teleport to="body">
        <TheModal v-if="showStayInTheLoop" @close-modal="showStayInTheLoop = false">
          <template #content>
            <FormsSignUp @close-modal="showStayInTheLoop = false" />
          </template>
        </TheModal>
      </Teleport>
    </template>
  </HomeFeature>
</template>
